/* eslint-disable max-lines */
import { useMemo } from 'react'
import { CECB, useI18n } from '@popety_io/popety-io-lib'
import { Box, Typography } from '@mui/material'

export const CECBLimitValue = {
  A: {
    min: 0,
    max: 50,
  },
  B: {
    min: 51,
    max: 90,
  },
  C: {
    min: 91,
    max: 150,
  },
  D: {
    min: 151,
    max: 230,
  },
  E: {
    min: 231,
    max: 330,
  },
  F: {
    min: 331,
    max: 450,
  },
  G: {
    min: 451,
    max: undefined,
  },
  'N/A': {
    min: undefined,
    max: undefined,
  },
}

const CECBSection = ({ data }: any) => {
  const { t } = useI18n()

  const values = useMemo(
    () => ({
      envelopeValue: data?.performance_heating_value,
      energyValue: data?.performance_energy_value,
      directCO2Value: data?.direct_CO2_emission_value,
      directCO2Type: data?.direct_CO2_emission_type || 'N/A',
      energyType: data?.performance_energy_type || 'N/A',
      envelopeType: data?.performance_heating_type || 'N/A',
    }),
    [data],
  )

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBlock: '16px',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            marginBottom: '4px',
            fontSize: '1.1rem',
            textTransform: 'uppercase',
          }}
        >
          CECB
        </Typography>
      </Box>
      <CECB
        directCO2Type={values.directCO2Type || 'N/A'}
        directCO2Value={values.directCO2Value}
        energyType={values.energyType}
        energyValue={values.energyValue}
        envelopeType={values.envelopeType}
        envelopeValue={values.envelopeValue}
        directCO2Unit="m3"
        isEdit={false}
        onChange={() => {}} // eslint-disable-line @typescript-eslint/no-empty-function
        t={t}
      />
    </div>
  )
}

export default CECBSection
